"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _richTextField = require("../../lib/richTextField");
var _lodash = require("lodash");
var _titleHeadTag = require("../../lib/titleHeadTag");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Title and Description Component
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A React Element
 */
function TitleTaglineDisplay(props) {
  if (!props.rendering.fields) return null;
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var ContentAlignClassName = extractedFields.CenterAlign.value === 'title-tagline' ? 'mm-text-center' : '';
  var titleClassName = extractedFields.CenterAlign.value === 'title-only' ? 'mm-text-center' : '';
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: ContentAlignClassName
  }, !(0, _lodash.isEmpty)(extractedFields.Title.value) && (0, _titleHeadTag.headTagTitle)(extractedFields.Title, titleClassName, extractedFields.TitleSize.value), !(0, _lodash.isEmpty)(extractedFields.PreviewText.value) && /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, (0, _richTextField.parseHTML)(extractedFields.PreviewText)));
}
var _default = exports.default = TitleTaglineDisplay;